import { render, staticRenderFns } from "./EvaluateAI.vue?vue&type=template&id=28ce2fa9&scoped=true&"
import script from "./EvaluateAI.vue?vue&type=script&lang=js&"
export * from "./EvaluateAI.vue?vue&type=script&lang=js&"
import style0 from "./EvaluateAI.vue?vue&type=style&index=0&id=28ce2fa9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ce2fa9",
  null
  
)

export default component.exports